export default {
  ERRORMODAL_01: 'ERRORMODAL_01',
  ERRORMODAL_02: 'ERRORMODAL_02',
  ERRORMODAL_03: 'ERRORMODAL_03',
  ERRORMODAL_04: 'ERRORMODAL_04',
  ERRORMODAL_05: 'ERRORMODAL_05',
  ERRORMODAL_06: 'ERRORMODAL_06',
  ERRORMODAL_07: 'ERRORMODAL_07',
}
